import React, { useState } from 'react'
import { Navbar } from 'react-bootstrap'
import { Container } from 'reactstrap'
import './OnboardingHeader.scss'
import { Button } from 'antd'

const OnboardingHeader = ({ onSaveAndLogout, btnTitle, showSaveAndLogout = true }) => {
  const [loading, setLoading] = useState(false)
  return (
    <div className="acclrtr-onboarding-header-main-wrap">
      <Navbar>
        <Container fluid className="mt-3 px-3">
          <Navbar.Brand href="/" className="">
            <div
              className={
                window.location.href.includes('onboarding') ? 'onboardingHeaderLogo' : 'authHeaderLogo'
              }
            ></div>
          </Navbar.Brand>
          {onSaveAndLogout && showSaveAndLogout && (
            <Button
              loading={loading}
              className="save-logout-btn"
              onClick={() => {
                // onSaveAndLogout()
                setLoading(true)
                window.location.href = '/accelerator'
              }}
            >
              {btnTitle || 'Save & Logout'}
            </Button>
          )}
        </Container>
      </Navbar>
    </div>
  )
}

export default OnboardingHeader
